import classNames from 'classnames';
import moment from 'moment';

import Cross from '../../../../../assets/images/icon-filled-cross-dark.svg';
import { CheckIcon } from '../../../../../icons';
import type { EnrolmentDetail, TutorTimeSlot } from '../../../../../types/hubInterfaces';
import { DATE_FORMAT_TYPE_8, SESSION_TIME_FORMAT } from '../../../../../util/constants';

export interface SessionAddedMessageProps {
  tutorName: string;
  enrolmentDetails: EnrolmentDetail;
  timeSlot: TutorTimeSlot;
  timezone: string;
  voucherWasUsed?: boolean;
  onDismiss: () => void;
  className?: string;
}

export const SessionAddedMessage = ({
  tutorName,
  enrolmentDetails,
  timeSlot,
  timezone,
  voucherWasUsed,
  onDismiss,
  className,
}: SessionAddedMessageProps) => {
  const sessionStart = moment.utc(timeSlot.start).tz(timezone);
  const sessionEnd = moment.utc(timeSlot.end).tz(timezone);

  return (
    <div
      className={classNames(
        'relative mb-8 rounded-lg border border-grey-2 bg-blood-orange-1 px-6 py-8 text-center lg:mb-8 lg:px-10 lg:py-10',
        className
      )}
    >
      <button
        type="button"
        onClick={onDismiss}
        className="absolute right-4 top-4 p-1 hover:opacity-70"
        aria-label="Close"
      >
        <img src={Cross} alt="" className="h-4 w-4" />
      </button>
      <div className="mx-auto flex h-[40px] w-[40px] items-center justify-center rounded-full bg-green-4">
        <CheckIcon className="text-white" width={40} height={40} />
      </div>
      <h2 className="merriweather-important my-4 text-2xl font-bold">Session added</h2>
      <div className="flex flex-col items-center gap-4 text-lg">
        <p>
          {`A session with ${tutorName} has been added to ${enrolmentDetails.studentName}'s Year ${enrolmentDetails.yearAsInteger} ${enrolmentDetails.enrolmentSubject} schedule:`}
        </p>
        <div className="font-bold">
          <div>{sessionStart.format(DATE_FORMAT_TYPE_8)}</div>
          <div>{`${sessionStart.format(SESSION_TIME_FORMAT)} – ${sessionEnd.format(SESSION_TIME_FORMAT)}`}</div>
        </div>
        {voucherWasUsed && <p>A Cluey Voucher was used to book this session.</p>}
      </div>
    </div>
  );
};
